export const styles: { [key: string]: React.CSSProperties } = {
  gameStats: {
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    top: "10px",
    right: "10px",
    fontSize: "30px",
    fontWeight: "bold",
    color: "white",
    WebkitTextStroke: "1px black",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    borderRadius: "10px",
    padding: "0px 10px 0px 10px",
    zIndex: 1,
  },
  innerDiv: {
    display: "flex",
    flexDirection: "row",
  },
};
